/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CoreModule } from '@dm/core';

import { ModifyUserQuotaModule } from '../modify-user-quota/modify-user-quota.module';
import { CreateFrontTableUserQuotaModule } from './create-front-table-user-quota/create-front-table-user-quota..module';
import { FrontTableUserQuotaComponent } from './front-table-user-quota.component';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        FormsModule,
        ModifyUserQuotaModule,
        CreateFrontTableUserQuotaModule,
    ],
    declarations: [FrontTableUserQuotaComponent],
    exports: [FrontTableUserQuotaComponent],
})
export class FrontTableUserQuotaModule { }
